export default __webpack_public_path__ + "static/media/Real-Time Bluedot Wayfinding.61b7863e.svg";